import React, { FC, useCallback, useMemo } from "react";
import { Pane } from "evergreen-ui";
import {
    AbstractTableViewProvider
} from "../../common/tables/view/AbstractTableViewProvider";
import {
    queryAllCostPayoutModifiers
} from "../../datastore/CostPayoutModifierDataStore";
import {
    CostPayoutModifierTableRow
} from "../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { CostPayoutModifier } from "../../../../common/models";
import { DefaultCPMTableConfig } from "./tables/config/DefaultCPMTableConfig";
import { CPMTableCellFactory } from "./factory/CPMTableCellFactory";
import { TableCellFactory } from "../../common/tables/factory";
import { TableView } from "../../common/tables/view/TableView";
import { TablePageHeader } from "../../common/tables/view/TablePageHeader";
import { RampartAuthorized } from "../../rampart/RampartAuthorized";

const cpmTableCellFactory: TableCellFactory<CostPayoutModifierTableRow, CostPayoutModifier> = new CPMTableCellFactory();

export const CostPayoutModifierListPage: FC = () => {
    const queryTableData = useCallback(() => {
        return queryAllCostPayoutModifiers({ take: 1000 });
    }, []);

    const onUpdateRow = useCallback((
        costPayoutModifiers: CostPayoutModifier[],
        _id: string | number,
        _columnName: keyof CostPayoutModifierTableRow,
        _value: string | number | boolean | null,
        _label?: string,
    ): CostPayoutModifier[] => {
        return costPayoutModifiers;
    }, []);

    const emptyViewProps = useMemo(() => {
        return {
            primaryText: "No cost payout modifiers found",
            secondaryText: "",
        };
    }, []);

    const errorViewProps = useMemo(() => {
        return {
            primaryText: "Failed to load cost payout modifiers",
            secondaryText: "Refresh the page to try again",
        };
    }, []);

    return (
        <RampartAuthorized requiredGroups={["juniper.self-serve.admin"]}>
            <Pane height={"100%"} display={"flex"} flexDirection={"column"}>
                <TablePageHeader
                    title={"Cost Payout Modifiers"}
                    addButtonText={"Add Modifier"}
                    addButtonOnClick={() => {}}
                />
                <AbstractTableViewProvider
                    queryTableData={queryTableData}
                    onUpdateRow={onUpdateRow}
                    updateRowLoading={false}
                    updateRowCalled={false}
                    updateRowError={false}
                    tableCellFactory={cpmTableCellFactory}
                    savedTableConfigProps={{
                        tableName: "costPayoutModifiers",
                        identifiers: ["v1"],
                        defaultConfigValue: DefaultCPMTableConfig,
                    }}
                >
                    <TableView
                        errorViewProps={errorViewProps}
                        emptyViewProps={emptyViewProps}
                    />
                </AbstractTableViewProvider>
            </Pane>
        </RampartAuthorized>
    );
};
